import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DefaultLangChangeEvent, TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../core/helpers/auth.service';
import { CoreService } from '../../core/helpers/core.service';
import { LegalModalsService } from '../shared/services/legal-modals.service';

@Component({
  selector: 'loyaltic-cashback',
  templateUrl: './cashback.component.html',
  styleUrls: ['./cashback.component.scss']
})
export class CashbackComponent implements OnInit {

   @ViewChild('uploadAnimation', { static: false }) uploadAnimationRef: any;
  @ViewChild('confirmReceiptUpload', { static: false }) confirmReceiptUploadRef: any;
  @ViewChild('tryagainReceiptUpload', { static: false }) tryagainReceiptUploadRef: any;
  @ViewChild('ipscanFailedMessage', { static: false }) ipscanFailedMessageRef: any;
  @ViewChild('thankyouApprovedPopup', { static: false }) thankyouApprovedPopupRef: any;
  @ViewChild('thankyouNotApprovedPopup', { static: false }) thankyouNotApprovedPopupRef: any;
  @ViewChild('confirmBankDetails', { static: false }) confirmBankDetailsPopupRef: any;


  public modalRef: BsModalRef;

  popupConfig = {
    ignoreBackdropClick: true,
    class: 'lyltc animation modal-md modal-dialog-centered modal-dialog-animation',
  };

  confirmPopupConfig = {
    ignoreBackdropClick: true,
    class: 'lyltc modal-md modal-dialog-centered',
  };

  receipt: any;
  Quantity = 1;
  ReceiptName = '';
  IsAcceptTerms = false;
  IsAcceptReview = false;
  IsPrivacyPolicy = false;
  IsUserAlreadyLoggedIn = false;
  receiptSrc: any;
  receiptNotApprovedData: any;
  submitted = false;
  hasIBANerror = false;
  IsBaazarVoiceSelected = false;
  permission = false;

  Name = '';
  BankNumber = '';
  userRewardRowKey = '';
  
  culture = '';

  @Output() receiptUploadSuccess = new EventEmitter<any>();

  constructor(private authService: AuthService, private coreService: CoreService,
    private toast: ToastrService, private translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private legalModalsService: LegalModalsService,
    private modalService: BsModalService) {
    this.culture = translate.getDefaultLang();


  }


  ngOnInit() {
    this.resetToken();

    this.route.queryParamMap.subscribe(params => {
      this.userRewardRowKey = params.get('id');
    });

    // const userId = this.authService.getUserId();
    // if (userId) {
    //   this.IsUserAlreadyLoggedIn = true;
    //   this.Email = localStorage.getItem('EmailId');
    // }
  }

  // ngAfterViewInit() {
  //   this.modalRef = this.modalService.show(this.confirmReceiptUploadRef, this.confirmPopupConfig);
  // }

  resetToken() {
    const tokenTime = this.authService.getTokenTime();
    if (tokenTime) {
      const differenceMs = +new Date().getTime() - +new Date(tokenTime).getTime();
      const sec = differenceMs / 1000;
      const hours = sec / 3600;
      if (hours > 24) { this.authService.resetTokens() }
    }
  }
  

  sortData(column: string, data: any) {
    const sortOrder = 'asc';
    data.sort((a, b) => {
      if (a[column] < b[column]) {
        return sortOrder === 'asc' ? -1 : 1;
      } else if (a[column] > b[column]) {
        return sortOrder === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    return data;
  }

  onReceiptSelect(event) {
    this.receipt = event.target.files[0];
    this.ReceiptName = this.receipt.name;
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (e: any) => {
        const img = document.createElement('img');
        img.src = e.target.result;
        this.receiptSrc = e.target.result;
      };
    }
  }

  showAnimationPopup() {
    this.modalRef = this.modalService.show(this.uploadAnimationRef, this.popupConfig);
  }

  onConfirm(form) {
    this.modalRef = this.modalService.show(this.confirmBankDetailsPopupRef, this.popupConfig);
  }

  onReceiptUpload() {
    this.modalRef.hide();
    this.submitted = true;

    const userId = this.authService.getUserId();
    const formData = new FormData();
    if (this.Quantity > 20) {
      return;
    }

    formData.append('Quantity', this.Quantity.toString());
    formData.append('Receipt', this.receipt);
    formData.append('Name', this.Name);;
    formData.append('IBAN', this.BankNumber);
    formData.append('UserRewardRowKey', this.userRewardRowKey);

    this.coreService.submitCashback(formData).then((response: any) => {
      this.hasIBANerror = false;
      this.modalRef.hide();

      this.submitted = false;
      this.resetForm();
      const result = response.result;
      localStorage.setItem('isWithFlow', '1');
      this.modalRef = this.modalService.show(this.thankyouApprovedPopupRef, this.confirmPopupConfig);
      
    }, (error:any) => {
      this.modalRef.hide();
      this.toast.error(this.translate.instant(error.error.messageKey), this.translate.instant('error'))
      
      //this.modalRef = this.modalService.show(this.tryagainReceiptUploadRef, this.confirmPopupConfig);
    });
    // in catch block -   this.gtmService.pushPage('/participation-form/error'); // gtm service

  }


  resetForm() {
    this.Quantity = undefined;
    this.receipt = undefined;
    this.ReceiptName = undefined;
    this.IsAcceptTerms = false;
    this.IsAcceptReview = false;
    this.IsPrivacyPolicy = false;
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  public removeSpace() {
    if (this.BankNumber.length > 0) {
      this.BankNumber = this.BankNumber.replace(/\s/g, '');
    }
  }

  freshParticipation() {
    this.authService.resetTokens();
    this.router.navigate([this.router.url])
  }

  openPolicyModal() {
    this.legalModalsService.openPolicy();
  }

}
